import { render, staticRenderFns } from "./ClicSwagger.vue?vue&type=template&id=40dbee9b&"
import script from "./ClicSwagger.vue?vue&type=script&lang=js&"
export * from "./ClicSwagger.vue?vue&type=script&lang=js&"
import style0 from "./ClicSwagger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports